import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { I140FileUploadConfiguration, TreeNode, labelNotNeededArray } from 'app-models';
import { FbSimpleFormService } from './fb-simple-form.service';
import { ToastrService } from 'ngx-toastr';
import { take, takeUntil } from 'rxjs/operators';
import { VdCustomFileUploadService } from 'vd-custom-file-upload';
import { Subject, Subscription } from 'rxjs';
import { CustomButtonActionService } from 'custom-button-action';
import { FdButtonFormCreationService } from '../../form-designer/fd-button-form-creation/fd-button-form-creation.service';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'dirty-check-store';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/data/models/app-state';
import moment from 'moment';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-fb-simple-form',
  templateUrl: './fb-simple-form.component.html',
  styleUrls: ['./fb-simple-form.component.scss']
})
export class FbSimpleFormComponent implements OnInit, OnChanges {
  @Input() simpleFormButton: any;
  @Input() pageFormType: string;
  // @Input() pageBuilderInfoDetails: any;
  @Input() formTypeSelected: any;
  @Input() formBuilderInfo: any;
  @Input() fields: any;
  @Input() stepNumber: any;
  allFields: any;
  htmlRenderObj: any;
  htmlStructure: {
    row: number,
    columns: any
  }[] = [];
  labelNotNeededArray: string[];
  stepsForm: FormGroup = new FormGroup({});
  fileUploadConfigurations: I140FileUploadConfiguration;
  documentTypeDropdownCode: any;
  companyId: number;

  formDataId: number = null;
  @Output() backToMasterList = new EventEmitter();
  @Input() isFBModulePreview = false;
  @Input() dataFormId: number;
  formDataInfo: any;
  saveCancelBtn: any;
  isFBUser: boolean;
  actionButtons = [];
  observableSubscription$ = new Subject();
  isMultiDataSrc: boolean;
  @Input() isMultiStep: boolean = false;
  @Input() currentStep: number = 0;
  @Input() steps: any[] = [];
  isInitialData: boolean = false;
  showContainerBasedonRole: boolean;
  updatedRenderObj: any;
  subscription: Subscription;
  isCreateTimeSheetSubmit: boolean;
  actionName: string | null = null;
  prevRedirectPageFormId: number;
  buildFormatTypeId: number;
  hideBackButton: boolean;

  constructor(
    private fbSimpleFormService: FbSimpleFormService,
    public toastrService: ToastrService,
    public vdCustomFileUploadService: VdCustomFileUploadService,
    private customButtonActionService: CustomButtonActionService,
    private fdButtonFormCreationService: FdButtonFormCreationService,
    protected store: Store<AppState>,
    private dialog: MatDialog
  ) {
    this.isFBUser = 'isFBUser' in sessionStorage ? sessionStorage.getItem('isFBUser') === 'true' : false;
    this.companyId = parseInt(sessionStorage.getItem('companyId'));
    this.labelNotNeededArray = labelNotNeededArray;
    this.htmlStructure = [];
    this.htmlRenderObj = null;
    const dashboardNotificationType = sessionStorage.getItem('dashboardNotificationType');
    if (dashboardNotificationType) {
      this.hideBackButton = ['TANewApplicant', 'TA Postposition'].includes(dashboardNotificationType);
    } else {
      this.hideBackButton = false;
    }
  }

  ngOnChanges(): void {
    if ((this.simpleFormButton && this.pageFormType && this.formTypeSelected) || this.dataFormId) {
      this.getFormData();
      // this.buildFormData(this.simpleFormButton.pageFormJson);
    } else {
      this.resetControls();
    }
  }

  resetControls() {
    this.stepsForm = new FormGroup({});
    this.htmlStructure = [];
    this.htmlRenderObj = null;
    this.fileUploadConfigurations = null;
  }

  setFileUploadConfigurationValue() {
    // Replacing presentMenu id if menuId is null
    const selectedMenu = (JSON.parse(sessionStorage.getItem('selectedMenu')) as TreeNode);
    const menuId = this.formBuilderInfo.menuId || selectedMenu.value;

    this.fileUploadConfigurations = {
      disableControls: false,
      isDocumentTypeRequired: true,
      isDocumentUploadRequired: true,
      isViewEnabled: true,
      isDownloadEnabled: true,
      isDeleteEnabled: true,
      getDocTypeApiUrl: `/referenceLibrary/${this.documentTypeDropdownCode}`,
      getApiUrl: `/vd/formBuilder/fetchAll/uploadedDocs/`,
      postApiUrl: `/vd/formBuilder/uploadDoc/formData/company/${this.companyId}/module/${this.formBuilderInfo.moduleId}/menu/${menuId}/form/${this.formBuilderInfo.id}?`,
      deleteApiUrl: `/vd/formBuilder/formDataDocs/delete/`,
      documentTypeDropdownCode: this.documentTypeDropdownCode,
      isFormBuilder: true,
      fbFormDataId: this.dataFormId ? this.dataFormId : ('formDataId' in sessionStorage ? parseInt(sessionStorage.getItem('formDataId')) : null)
    };
  }

  ngOnInit() {
    this.vdCustomFileUploadService.formDataIdChanges
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe((data) => {
        this.dataFormId = data.dataFormId
      });

    this.stepsForm.valueChanges
      .pipe(
        takeUntil(this.observableSubscription$)
      )
      .subscribe(() => {
        const dirty = this.stepsForm.dirty;
        const action = dirty
          ? new MarkDirtyFormAction({ dirty: true })
          : new MarkCleanFormAction({ dirty: false });

        this.store.dispatch(action);
      });
    if (this.steps && this.steps.length > 0) {
      this.allFields = this.steps.reduce((accumulator, currentStep) => {
        return accumulator.concat(currentStep.fields);
      }, []);
    }
    this.customButtonActionService.actionName$.subscribe(actionName => {
      this.actionName = actionName;
    });
  }

  private updateHtmlRenderObj() {
    const keys = Object.keys(this.stepsForm.value);

    keys.forEach(key => {
      const htmlRenderObjIndex = this.getHtmlRenderObjIndex(key);

      if (htmlRenderObjIndex > -1) {
        const columnObj = this.simpleFormButton.isMultiDataSrc
          ? this.allFields[htmlRenderObjIndex]
          : (this.isMultiStep ? this.htmlRenderObj[htmlRenderObjIndex] : this.updatedRenderObj[htmlRenderObjIndex]);

        const layoutCode = columnObj?.layoutCode;
        const value = this.stepsForm.value[key];

        switch (layoutCode) {
          case 'CustomGridEditor':
            columnObj.gridValues = value.gridValues;
            break;
          case 'VdSwitchGroupComponent':
            this.updateSwitchGroupValue(columnObj, value);
            break;
          case 'CustomQuestionsGroupComponent':
            columnObj.questionCheck = value;
            columnObj.value = value;
            break;
          case 'CustomCalenderComponent':
            columnObj.value = value || '';
            break;
          default:
            columnObj.value = value;
            break;
        }
      }
    });
  }

  private getHtmlRenderObjIndex(key: string): number {
    const findIndexCondition = x =>
      ['VdEadLibraryComponent', 'VdCountryStateComponent'].includes(x.layoutCode)
        ? x.groupName === key
        : x.name === key;
    return this.simpleFormButton.isMultiDataSrc
      ? this.allFields.findIndex(findIndexCondition)
      : (this.isMultiStep ? this.htmlRenderObj.findIndex(findIndexCondition) : this.updatedRenderObj.findIndex(findIndexCondition));
  }

  private updateSwitchGroupValue(columnObj: any, value: any) {
    const switchGridProps = columnObj.groupElementProperty;
    let additionalInfo = '';

    if (switchGridProps?.whenTextAreaShown === 'off') {
      additionalInfo = value.switch_field === true ? '' : value.additional_info_for_switch_field;
    } else if (switchGridProps?.whenTextAreaShown === 'on') {
      additionalInfo = value.switch_field === false ? '' : value.additional_info_for_switch_field;
    } else {
      additionalInfo = value.additional_info_for_switch_field;
    }

    columnObj.value = {
      switch_field: value.switch_field,
      additional_info_for_switch_field: additionalInfo
    };
    columnObj.questionCheck = value.switch_field;
  }

  private createPayload() {
    const payload: any = {};
    payload.companyId = 'companyId' in sessionStorage ? parseInt(sessionStorage.getItem('companyId')) : null;
    let formDateJsonPayload = this.simpleFormButton.isMultiDataSrc ? this.allFields : (this.isMultiStep ? this.htmlRenderObj : this.updatedRenderObj);
    if (this.simpleFormButton.isMultiDataSrc) {
      const savedStepNumber = this.currentStep + 1;
      formDateJsonPayload = formDateJsonPayload.map(field => ({ ...field, savedStepNumber }));
      payload.savedStepNumber = savedStepNumber;
    }
    payload.formDateJson = JSON.stringify(formDateJsonPayload);
    payload.actionName = this.actionName;

    payload.currentDateTime = moment(new Date()).format('yyyy-MM-DD HH:mm:ss');
    if (this.simpleFormButton.formUniqueName === 'HR_ADMIN_POST_POSITION') {
      payload.id = null;
    } else {
      payload.id = this.dataFormId ? this.dataFormId : ('formDataId' in sessionStorage ? parseInt(sessionStorage.getItem('formDataId')) : null);
    }
    payload.fdUploadedDocIdsList = [];
    payload.formDataId = 'formDataId' in sessionStorage ? parseInt(sessionStorage.getItem('formDataId')) : null;
    payload.employeeId = 'FbActualEmployeeId' in sessionStorage ? parseInt(sessionStorage.getItem('FbActualEmployeeId')) : 'employeeId' in sessionStorage ? parseInt(sessionStorage.getItem('employeeId')) : null;

    if (this.dataFormId && this.formDataInfo) {
      payload.formId = this.formDataInfo?.formId ? this.formDataInfo.formId : null;
      payload.formButtonId = this.formDataInfo?.formButtonId ? this.formDataInfo.formButtonId : null;
    } else {
      payload.formId = this.simpleFormButton?.formBuilderPageFormId ? this.simpleFormButton.formBuilderPageFormId : null;
      payload.formButtonId = this.simpleFormButton?.id ? this.simpleFormButton.id : null;
    }

    payload.selectedMultiRows = 'selectedRowIds' in sessionStorage ? JSON.parse(sessionStorage.getItem('selectedRowIds')) : null;
    payload.listId = 'AttendanceDataId' in sessionStorage ? parseInt(sessionStorage.getItem('AttendanceDataId')) : null;

    if (payload.listId === null) {
      delete payload.listId;
    }
    payload.masterListRowId = null;
    if ('idToGetDetails' in sessionStorage) {
      payload.masterListRowId = Number(sessionStorage.getItem('idToGetDetails'));
    } else if ('fbFormDataDTO' in sessionStorage) {
      const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
      payload.masterListRowId = Number(fbFormDataDTO[fbFormDataDTO.length - 1].id);
    }

    payload.masterListRowDTO = null;
    if ('fbFormDataDTO' in sessionStorage) {
      const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
      payload.masterListRowDTO = fbFormDataDTO[fbFormDataDTO.length - 1];
    } else if ('fbEditFormDataDTO' in sessionStorage) {
      payload.masterListRowDTO = JSON.parse(sessionStorage.getItem('fbEditFormDataDTO')) as any;
    }

    return payload;
  }

  private handleSuccessResponse(response: any, isRedirect: boolean, pageFormId: number, isCurrentRedirect: boolean) {
    this.store.dispatch(new MarkCleanFormAction({
      dirty: false
    }));
    this.toastrService.success(response.message, 'Success');
    this.dataFormId = response.data?.id || null;
    sessionStorage.setItem('employeeId', response?.data?.employeeId);
    const redirectPageFormId = 'redirectPageFormId' in sessionStorage ? parseInt(sessionStorage.getItem('redirectPageFormId')) : null;
    if (isRedirect && pageFormId) {
      this.handleRedirect(pageFormId);
    } else if (isCurrentRedirect) {
      this.handleRedirect(redirectPageFormId);
    } else {
      if (this.pageFormType === 'master_listing_table') {
        this.removeLastItemFbFormDataDTO();
        this.backToMasterList.next();
      } else if (this.pageFormType === 'simple_form') {
        this.getFormData();
      }
    }
  }

  onSave(isRedirect: boolean, pageFormId: number, isCurrentRedirect: boolean, value?: string) {
    if (this.isFBModulePreview && this.pageFormType === 'master_listing_table') {
      this.backToMasterList.next();
      return;
    }

    this.updateHtmlRenderObj();

    const payload = this.createPayload();
    payload.isSaveOnly = (value && value === 'SAVE') ? true : false;
    this.fbSimpleFormService.saveFormBuilderSimpleForm(payload)
      .pipe(take(1))
      .subscribe(response => {
        if (response?.status === 200) {
          this.handleSuccessResponse(response, isRedirect, pageFormId, isCurrentRedirect);
        }
      });
  }
  handleRedirect(pageFormId: number) {
    this.customButtonActionService.getPageFormById(pageFormId)
      .pipe(take(1)).subscribe((response: any) => {
        if (response) {
          if ('fbFormDataDTO' in sessionStorage) {
            this.removeLastItemFbFormDataDTO();
            if ('fbFormDataDTO' in sessionStorage && sessionStorage.getItem('fbFormDataDTO') !== null && sessionStorage.getItem('fbFormDataDTO') !== '[null]') {
              const fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
              sessionStorage.setItem('idToGetDetails', fbFormDataDTO[fbFormDataDTO.length - 1].id);
            }
            else {
              sessionStorage.removeItem('idToGetDetails');
            }
          }
          const item = {
            formType: response.buildFormatTypeId,
            pageFormId: response.id
          }
          this.customButtonActionService.onLinkRedirectPageSubject.next(item);
        }
      });
  }
  getFormData() {
    //this.resetControls();
    this.htmlStructure = [];
    this.htmlRenderObj = null;
    this.fileUploadConfigurations = null;
    this.buildFormatTypeId = 'buildFormatTypeId' in sessionStorage ? parseInt(sessionStorage.getItem('buildFormatTypeId')) : null;
    this.prevRedirectPageFormId = 'mlPageFormId' in sessionStorage ? parseInt(sessionStorage.getItem("mlPageFormId")) : null;
    if (this.simpleFormButton && this.simpleFormButton.isCreateNew) {
      this.buildFormData(this.simpleFormButton.pageFormJson, true);
      return;
    }

    const excludedFormNames = ["GENERATE_BILLING_RECEIPT", "VIEW_REQUISITIONS_DETAILS", "HR_ADMIN_POST_POSITION"];
    if (this.dataFormId && !excludedFormNames.includes(this.simpleFormButton?.formUniqueName)) {
      this.fetchFormDataById();
      return;
    }

    if (this.simpleFormButton && this.simpleFormButton.formBuilderPageFormId) {
      this.fetchFormDataByPageFormId();
    }
  }

  fetchFormDataById() {
    this.fbSimpleFormService.getPageFormData(this.dataFormId)
      .pipe(take(1))
      .subscribe((response: any) => {
        if (!response) return;

        this.formDataInfo = response;
        if (this.simpleFormButton) {
          this.buildFormData(response.formDateJson);
        } else {
          this.fetchPageFormDetailsByButtonId();
        }
      });
  }

  fetchPageFormDetailsByButtonId() {
    this.fdButtonFormCreationService.getPageFormDetailsByButtonId(this.formDataInfo.formButtonId)
      .pipe(take(1))
      .subscribe((data: any) => {
        this.simpleFormButton = data || null;
        if (this.simpleFormButton) {
          this.buildFormData(this.formDataInfo.formDateJson);
        }
      });
  }

  fetchFormDataByPageFormId() {
    const employeeId = 'FbActualEmployeeId' in sessionStorage ? parseInt(sessionStorage.getItem('FbActualEmployeeId')) : null;
    const interviewProcessId = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
    // const redirectPageFormId = 'pageFormId' in sessionStorage ? parseInt(sessionStorage.getItem('pageFormId')): null;
    // const currentPageFormId = 'currentPageFormId' in sessionStorage ? parseInt(sessionStorage.getItem('currentPageFormId')): null;
    // const idToGetDetails = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')): null;
    const entityId = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
    const formDataId = 'formDataId' in sessionStorage ? parseInt(sessionStorage.getItem('formDataId')) : null;
    const serviceCall = this.simpleFormButton.isMultiDataSrc
      ? (interviewProcessId ? this.fbSimpleFormService.getPageFormDataByApplicantId(interviewProcessId) : null)
      : (employeeId ?
        this.fbSimpleFormService.getPageFormDataByEmployeeId(this.simpleFormButton.formBuilderPageFormId, employeeId, entityId) :
        // redirectPageFormId && currentPageFormId && idToGetDetails ? this.fbSimpleFormService.getDataFromPageFormIdsAndId(currentPageFormId, redirectPageFormId, idToGetDetails) :
        (formDataId && this.simpleFormButton.formUniqueName === "HR_ADMIN_POST_POSITION"
          ? this.fbSimpleFormService.getPageFormByFormDataId(this.simpleFormButton.formBuilderPageFormId, formDataId)
          : this.fbSimpleFormService.getPageFormDataByPageformId(this.simpleFormButton.formBuilderPageFormId)
        ));
    serviceCall.pipe(take(1)).subscribe((response: any) => {
      if (response) {
        this.formDataInfo = response;
        this.dataFormId = this.formDataInfo.id;
        if (employeeId) {
          sessionStorage.setItem('genRecieptFileId', this.formDataInfo.id)
        }
        this.buildFormData(response.formDateJson);
      } else if (this.simpleFormButton.pageFormJson) {
        this.isInitialData = true;
        sessionStorage.removeItem('genRecieptFileId');
        this.buildFormData(this.simpleFormButton.pageFormJson, true);
      }
    });
  }

  onActionClicked(value: string, isRedirect: boolean, isCurrentRedirect: boolean, pageFormId: number) {
    this.htmlRenderObj.push({
      name: "submitAction",
      value: value,
      layoutCode: "submitButton"
    });
    this.onSave(isRedirect, pageFormId, isCurrentRedirect, value);
  }

  buildFormData(jsonData, isSimpleFormBtn: boolean = false) {
    if (!jsonData) {
      // Handle the case where jsonData is null
      return;
    }
    // Initialize data structures based on the condition
    this.initializeDataStructures(jsonData, isSimpleFormBtn);

    // Configure saveCancelBtn
    this.configureSaveCancelBtn();

    // Configure file upload properties if needed
    this.configureFileUpload();

    // Mark the form as pristine
    this.stepsForm.markAsPristine();
  }

  initializeDataStructures(jsonData, isSimpleFormBtn) {
    this.htmlStructure = [];
    this.htmlRenderObj = this.parseAndFilterJsonData(jsonData)
    if (this.simpleFormButton.isMultiDataSrc && !this.isInitialData) {
      const renderObj = this.parseAndFilterJsonData(jsonData);
      const newObjects = this.allFields.filter(filteredField => !renderObj.some(renderField => renderField.name.includes(filteredField.name.split('-')[0])));
      this.allFields = newObjects.length > 0 ? [...newObjects, ...renderObj] : renderObj;
    }
    this.filterFieldsByStepNumber();
    this.buildHtmlStructure(isSimpleFormBtn);
  }

  parseAndFilterJsonData(jsonData) {
    const parsedData = JSON.parse(jsonData);
    return parsedData.filter(x => !x.emptyCol && !x.isOmit && x.layoutCode !== 'submitButton');
  }

  filterFieldsByStepNumber() {
    if (this.isMultiStep) {
      const fieldsToRender = this.simpleFormButton.isMultiDataSrc || this.simpleFormButton.formUniqueName === "GENERATE_BILLING_RECEIPT" ? this.allFields : this.htmlRenderObj;
      this.fields = fieldsToRender.filter(item => item.stepNumber === this.stepNumber);
    }
  }
  buildHtmlStructure(isSimpleFormBtn) {
    const htmlStructure = [];
    let renderObj = this.isMultiStep ? this.fields : this.htmlRenderObj;
    const originalRenderObj = JSON.parse(JSON.stringify(renderObj));

    const sfBtnDataConfig = JSON.parse(this.simpleFormButton.pageFormJson);
    let filteredFields = sfBtnDataConfig.filter(field => !('emptyCol' in field && field.emptyCol) && !(field.isOmit === true));
    //Select newly added objects from sfBtnDataConfig
    const newObjects = filteredFields.filter(filteredField => !renderObj.some(renderField => renderField.name.includes(filteredField.name.split('-')[0])));

    //Removed Component and label based on configuration(status:posted) start
    let masterlistRowData = JSON.parse(sessionStorage.getItem('columnKeyValuePair')) as any;
    sessionStorage.removeItem('columnKeyValuePair');
    if (masterlistRowData) {
      const hideFieldsOnEdit = sfBtnDataConfig.filter(component =>
        !(component.hideEditComponentByStatus && masterlistRowData[component.hideColumnName] &&
          component.hideColumnValue?.length > 0 &&
          component.hideColumnValue.some(x => x.toLowerCase() === masterlistRowData[component.hideColumnName].toLowerCase())));
      if (!this.simpleFormButton.isMultiDataSrc) {
        renderObj = renderObj.filter(o1 => hideFieldsOnEdit.some(o2 => o1.name === o2.name));
      }
    }
    //Removed Component and label based on configuration(status:posted) end

    // Concatenate newly added objects with renderObj
    this.updatedRenderObj = newObjects.length > 0 && !this.isMultiStep ? [...newObjects, ...renderObj] : renderObj;

    //To render custom-grid-component changes when new columns(gridProperties) are added
    if (this.updatedRenderObj.some(item => item.layoutCode === 'CustomGridEditor')) {
      const hasDifferentLength = this.updatedRenderObj.some(item => {
        const filteredItem = filteredFields.find(filteredItem => filteredItem.name === item.name);
        return filteredItem && filteredItem.gridProperties && filteredItem.gridProperties.length !== item.gridProperties.length;
      });
      const hasDifferentColumnType = this.updatedRenderObj.some(item => {
        const filteredItem = filteredFields.find(filteredItem => filteredItem.name === item.name);
        if (filteredItem && filteredItem.gridProperties) {
          return filteredItem.gridProperties.some((prop, index) => {
            return prop.columnType !== item.gridProperties[index]?.columnType;
          });
        }
        return false;
      });
      if (hasDifferentLength || hasDifferentColumnType) {
        const mergedFields = filteredFields.map((filteredItem) => {
          const updatedItem = this.updatedRenderObj.find(
            (item) => item.name === filteredItem.name
          );

          if (updatedItem) {
            return {
              ...filteredItem,
              value: updatedItem.value || filteredItem.value
            };
          }
          return filteredItem;
        });

        this.updatedRenderObj.splice(0, this.updatedRenderObj.length, ...mergedFields);
        //this.updatedRenderObj.splice(0, this.updatedRenderObj.length, ...filteredFields);
        this.updatedRenderObj.forEach((item, index) => {
          const originalItem = originalRenderObj.find(originalItem => originalItem.name === item.name);
          if (originalItem && originalItem.gridValues) {
            item.gridValues = originalItem.gridValues;
          }
        });
      }
    }

    Array.from(new Set(this.updatedRenderObj.filter(x => x.numberOfRow).map(x => x.numberOfRow)))
      .forEach(rowNumber => {
        let columns = this.updatedRenderObj.filter(item => item.numberOfRow === rowNumber);
        const fbRoleId = 'fbRoleId' in sessionStorage ? Number(sessionStorage.getItem('fbRoleId')) : null;
        if (isSimpleFormBtn) {
          columns.map(item => {
            if (item.selectedRoles) {
              item.showContainerBasedonRole = item?.selectedRoles?.includes(fbRoleId);
            } else {
              item.showContainerBasedonRole = true;
            }
          })
        }
        else if (!isSimpleFormBtn) {
          columns = columns.map(valueItem => {
            const jsonDataName = this.simpleFormButton.isMultiDataSrc ? valueItem.name.split("-")[0] : valueItem.name;
            const matchingConfig = sfBtnDataConfig.find(configItem => configItem.name === jsonDataName);
            if (matchingConfig) {
              valueItem.maxLength = matchingConfig.maxLength || valueItem.maxLength || null;
              valueItem.minLength = matchingConfig.minLength || valueItem.minLength || null;
              valueItem.label = matchingConfig.label || valueItem.label || null;
              valueItem.showTodayByDefault = matchingConfig.showTodayByDefault || valueItem.showTodayByDefault || null;
              valueItem.mandatory = matchingConfig.mandatory || valueItem.mandatory || null;
              valueItem.selectedRoles = matchingConfig.selectedRoles || valueItem.selectedRoles || null;
              valueItem.showUploadDate = matchingConfig.showUploadDate || valueItem.showUploadDate || null;
              valueItem.disablePastDates = matchingConfig.disablePastDates || valueItem.disablePastDates || null;
              if (valueItem.selectedRoles) {
                valueItem.showContainerBasedonRole = valueItem.selectedRoles.includes(fbRoleId);
              } else {
                valueItem.showContainerBasedonRole = true;
              }
              if (valueItem.properties) {
                valueItem.properties.title = matchingConfig?.properties?.title || valueItem.properties.title || null;
              }
              valueItem?.gridProperties?.forEach((property, index) => {
                if (matchingConfig.gridProperties[index]) {
                  property.mandatory = matchingConfig.gridProperties[index].mandatory || null;
                  property.splCharAllowed = matchingConfig.gridProperties[index].splCharAllowed || null;
                  property.maxLength = matchingConfig.gridProperties[index].maxLength || null;
                  property.columnName = matchingConfig.gridProperties[index].columnName || null;
                  property.inputLabelName = matchingConfig.gridProperties[index].inputLabelName || null;
                }
              });
              if (matchingConfig.layoutCode === "CustomDropdownComponent") {
                if (valueItem.properties) {
                  valueItem.properties = {
                    ...valueItem.properties,
                    setValueOnLoad: matchingConfig.properties.setValueOnLoad ?? true
                  }
                } else {
                  valueItem.properties = { setValueOnLoad: matchingConfig.properties?.setValueOnLoad ?? true };
                }
              }
            }
            return valueItem;
          });
        }
        htmlStructure.push({
          row: Number(rowNumber),
          columns
        });
      });
    this.htmlStructure = JSON.parse(JSON.stringify(htmlStructure));

  }

  configureSaveCancelBtn() {
    let saveCancelBtn = JSON.parse(this.simpleFormButton.pageFormJson).find(x => x.isOmit);
    if (!saveCancelBtn.onSaveAction) {
      saveCancelBtn.onSaveAction = {
        isRename: false,
        reName: null,
        isRedirect: false,
        pageFormId: null
      };
    }
    this.saveCancelBtn = {
      ...saveCancelBtn,
      otherActionDetails: this.configureOtherActionDetails(saveCancelBtn.otherActionDetails)
    };
    this.subscription = this.vdCustomFileUploadService.gettimesheetCheckboxValue().subscribe(
      (data) => {
        setTimeout(() => {
          if (data.checkbox == true) {
            // if(this.htmlStructure[0]?.columns[0]?.name == "CREATE_PROJECT_TIMESHEET_lomu89hu4kb7s0b72sa"){
            //   this.isCreateTimeSheetSubmit = true;
            if (this.htmlStructure[1]?.columns[0]?.name == "FILE_UPLOAD_ltodxqrczykbwvcctej" || this.htmlStructure[0]?.columns[0]?.name == "CREATE_PROJECT_TIMESHEET_lomu89hu4kb7s0b72sa") {
              this.labelNotNeededArray.push("VdCustomFileUploadComponent");
              this.saveCancelBtn.onSaveAction = {};
              //this.saveCancelBtn.otherActionDetails = {};
              this.saveCancelBtn.otherAction = false;
              this.saveCancelBtn.save = false;
              this.saveCancelBtn.cancel = false;
            }
          } else {
            // if(this.htmlStructure[0]?.columns[0]?.name == "CREATE_PROJECT_TIMESHEET_lomu89hu4kb7s0b72sa"){
            //   this.isCreateTimeSheetSubmit = true;
            if (this.htmlStructure[1]?.columns[0]?.name == "FILE_UPLOAD_ltodxqrczykbwvcctej" || this.htmlStructure[0]?.columns[0]?.name == "CREATE_PROJECT_TIMESHEET_lomu89hu4kb7s0b72sa") {
              for (let order of this.labelNotNeededArray) {
                if (order === 'VdCustomFileUploadComponent') {
                  this.labelNotNeededArray.splice(this.labelNotNeededArray.indexOf(order), 1);
                  this.saveCancelBtn.onSaveAction = { "reName": 'Submit', "isRename": true, "isRedirect": false, "pageFormId": null };
                  // this.saveCancelBtn.otherActionDetails = { "isRedirect":false,"label": "Save","pageFormId": null,"values": "SAVE"}
                  this.saveCancelBtn.otherAction = true;
                  this.saveCancelBtn.save = true;
                  this.saveCancelBtn.cancel = true;
                  break;
                }
              }
            }
          }
        }, 100);
      });
  }

  configureOtherActionDetails(otherActionDetails) {
    return otherActionDetails
      ? otherActionDetails.map(x => ({
        ...x,
        isRedirect: x.isRedirect || false,
        pageFormId: x.isRedirect ? x.pageFormId : null
      }))
      : [];
  }

  configureFileUpload() {
    const obj = this.updatedRenderObj.find(item => item.layoutCode === 'VdCustomFileUploadComponent');
    this.documentTypeDropdownCode = obj?.properties?.refercenceCodeForApiCall || null;

    if (this.documentTypeDropdownCode) {
      this.setFileUploadConfigurationValue();
    }
  }

  removeLastItemFbFormDataDTO() {
    if ('formName' in sessionStorage) {
      let formName = sessionStorage.getItem('formName');
      if (formName !== 'TA View Applicant') {
        if ('fbFormDataDTO' in sessionStorage) {
          let fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
          if (fbFormDataDTO.length > 1) {
            fbFormDataDTO = fbFormDataDTO.slice(0, -1);
          }
          if (fbFormDataDTO.length === 0) {
            sessionStorage.removeItem('fbFormDataDTO');
          } else {
            sessionStorage.setItem('fbFormDataDTO', JSON.stringify(fbFormDataDTO));
          }
        }
      }
    } else {
      if ('fbFormDataDTO' in sessionStorage) {
        let fbFormDataDTO = JSON.parse(sessionStorage.getItem('fbFormDataDTO')) as any[];
        if (fbFormDataDTO.length > 1) {
          fbFormDataDTO = fbFormDataDTO.slice(0, -1);
        }
        if (fbFormDataDTO.length === 0) {
          sessionStorage.removeItem('fbFormDataDTO');
        } else {
          sessionStorage.setItem('fbFormDataDTO', JSON.stringify(fbFormDataDTO));
        }
      }
    }

  }

  goBack() {
    if (this.stepsForm.dirty) {
      const dialogRef = this.dialog.open(ConfirmationModalComponent, {
        width: '400px',
        data: {
          update: {
            title: 'Unsaved Changes!!',
            message: 'If you leave before saving, all changes made on the page will be lost. Do you wish to continue?'
          },
          buttons: ['No', 'Yes']
        }
      });
      dialogRef.afterClosed().subscribe(confirmed => {
        if (confirmed == true) {
          this.removeLastItemFbFormDataDTO();
          this.backToMasterList.next();
        }
      })
    }
    else {
      this.removeLastItemFbFormDataDTO();
      this.backToMasterList.next();
      this.store.dispatch(new MarkCleanFormAction({
        dirty: false
      }));
    }
    sessionStorage.removeItem('getFilesId');
  }

  onCancel(isRedirect: boolean, pageFormId: number) {
    if (isRedirect && pageFormId) {
      this.handleRedirect(pageFormId);
    } else {
      if (this.pageFormType === 'master_listing_table') {
        this.removeLastItemFbFormDataDTO();
        this.backToMasterList.next();
      } else if (this.pageFormType === 'simple_form') {
        if (this.isFBUser && this.dataFormId) {
          this.getFormData();
        }
      }
    }
  }
  onBack(isRedirect: boolean, pageFormId: number) {
    if (isRedirect && pageFormId) {
      this.handleRedirect(pageFormId);
    } else {
      if (this.pageFormType === 'master_listing_table') {
        this.removeLastItemFbFormDataDTO();
        this.backToMasterList.next();
      } else if (this.pageFormType === 'simple_form') {
        if (this.isFBUser && this.dataFormId) {
          this.getFormData();
        }
      }
    }
  }
  ngOnDestroy(): void {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    sessionStorage.removeItem('selectedRowIds');
    if (this.simpleFormButton.formUniqueName === 'SUBMIT_TO_CLIENT' || this.simpleFormButton.formUniqueName === 'SUBMIT_TO_SUPPLIER') {
      this.fbSimpleFormService.deleteClientUploadedDocs(this.dataFormId)
        .pipe(takeUntil(this.observableSubscription$))
        .subscribe((response: any) => {
          let res = response;
        });
    }
  }
}
